import React from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './home.css'

const Home = (props) => {
  return (
    <div className="home-container1">
      <Helmet>
        <title>Evelynis Holding Page</title>
        <meta property="og:title" content="Evelynis Holding Page" />
        <link
          rel="canonical"
          href="https://vast-pleased-grasshopper-rwhvnj.teleporthq.app/"
        />
      </Helmet>
      <Navigation></Navigation>
      <section className="hero-parallax-section">
        <div id="hero-bg" className="hero-parallax-bg">
          <img
            alt="Natural wood textures in warm light"
            src="https://images.pexels.com/photos/5089161/pexels-photo-5089161.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
            className="hero-parallax-img"
          />
        </div>
        <div className="hero-parallax-overlay"></div>
        <div className="hero-parallax-content">
          <h1 className="home-hero-title hero-title">
            Timeless Craft, Rooted in Nature.
          </h1>
          <p className="hero-subtitle">
            Handmade wooden boards from Grampa&apos;s Wiltshire Workshop,
            crafted with care for generations to come.
          </p>
          <div className="hero-actions">
            <a href="#collections">
              <div className="btn-primary btn btn-lg">
                <span>Shop Collections</span>
              </div>
            </a>
            <a href="#story">
              <div className="btn-outline btn btn-lg">
                <span>Our Story</span>
              </div>
            </a>
          </div>
        </div>
      </section>
      <section id="story" className="about-story-section">
        <div className="about-container">
          <div className="about-grid">
            <div className="about-image-wrapper">
              <img
                alt="Grampa crafting in his workshop"
                src="https://images.pexels.com/photos/5089120/pexels-photo-5089120.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                className="about-image"
              />
            </div>
            <div className="about-content">
              <h2 className="section-title">A Legacy Carved in Wiltshire</h2>
              <p className="section-subtitle">
                From Grampa&apos;s Hands to Evelyn&apos;s Future
              </p>
              <p className="section-content">
                In a quiet corner of Wiltshire, Grampa spends his days
                surrounded by the scent of sawdust and the warmth of seasoned
                oak. Every board he shapes is more than a kitchen tool;
                it&apos;s a promise of a sustainable future for his
                granddaughter, Evelyn. By sourcing timber responsibly and
                crafting each piece to last a lifetime, we ensure that the
                beauty of the forest remains for her to enjoy, just as we do
                today.
              </p>
              <p className="section-content">
                Our workshop is a place of quiet excellence, where tradition
                meets a deep respect for the natural world. Every knot and grain
                tells a story of the tree it came from and the hands that
                honored it.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section id="collections" className="explore-collections-section">
        <div className="explore-container">
          <div className="explore-header">
            <h2 className="section-title">The Collections</h2>
            <p className="section-subtitle">
              Tactile beauty for every occasion
            </p>
          </div>
          <div className="explore-grid">
            <div className="collection-card">
              <div className="collection-image-box">
                <img
                  alt="Wooden kitchen boards"
                  src="https://images.pexels.com/photos/15106429/pexels-photo-15106429.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  className="collection-image"
                />
              </div>
              <div className="collection-info">
                <h3 className="section-title">Kitchen</h3>
                <p className="section-content">
                  Durable, end-grain chopping boards designed for daily culinary
                  mastery and enduring resilience.
                </p>
                <a href="#">
                  <div className="btn-link btn">
                    <span>View Collection</span>
                  </div>
                </a>
              </div>
            </div>
            <div className="collection-card">
              <div className="collection-image-box">
                <img
                  alt="Wooden serving boards"
                  src="https://images.pexels.com/photos/15209817/pexels-photo-15209817.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  className="collection-image"
                />
              </div>
              <div className="collection-info">
                <h3 className="section-title">Serving</h3>
                <p className="section-content">
                  Elegant cheese and charcuterie boards that bring the warmth of
                  the Wiltshire woods to your table.
                </p>
                <a href="#">
                  <div className="btn-link btn">
                    <span>View Collection</span>
                  </div>
                </a>
              </div>
            </div>
            <div className="collection-card">
              <div className="collection-image-box">
                <img
                  alt="Special occasion boards"
                  src="https://images.pexels.com/photos/5095284/pexels-photo-5095284.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  className="collection-image"
                />
              </div>
              <div className="collection-info">
                <h3 className="section-title">Special Occasions</h3>
                <p className="section-content">
                  Bespoke heirloom pieces crafted to celebrate life&apos;s most
                  meaningful milestones and gatherings.
                </p>
                <a href="#">
                  <div className="btn-link btn">
                    <span>View Collection</span>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="showcase-christmas-section">
        <div className="showcase-content-wrapper">
          <div className="showcase-intro">
            <h2 className="section-title">A Wiltshire Christmas</h2>
            <p className="section-content">
              Handcrafted decorations made from the off-cuts of our larger
              boards. Sustainable, festive, and forever. Each piece is
              hand-painted and finished with natural oils.
            </p>
          </div>
          <div className="showcase-rail-outer">
            <div className="showcase-rail">
              <div className="showcase-card">
                <img
                  alt="Hand-painted wooden ornaments"
                  src="https://images.pexels.com/photos/6163743/pexels-photo-6163743.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  className="showcase-img"
                />
                <div className="showcase-card-overlay">
                  <span className="section-content">Painted Stars</span>
                </div>
              </div>
              <div className="showcase-card">
                <img
                  alt="Wooden bird ornament"
                  src="/ai-generated/ai-generated-1768417800191-500h.png"
                  className="showcase-img"
                />
                <div className="showcase-card-overlay">
                  <span className="section-content">Hanging Decorations</span>
                </div>
              </div>
              <div className="showcase-card">
                <div className="home-thq-showcase-grid-elm">
                  <div className="showcase-card">
                    <img
                      alt="Kitchen and serving wooden boards"
                      src="https://images.pexels.com/photos/10126392/pexels-photo-10126392.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=400"
                      className="showcase-card-img"
                    />
                    <h3 className="showcase-title">Kitchen &amp; Serving</h3>
                    <p className="showcase-description">
                      Handcrafted chopping and cheese boards
                    </p>
                  </div>
                  <div className="showcase-card">
                    <img
                      alt="Wooden mushroom LED light for children"
                      src="https://images.pexels.com/photos/3932937/pexels-photo-3932937.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=400"
                      className="showcase-card-img"
                    />
                    <h3 className="showcase-title">Mushroom LED Light</h3>
                    <p className="showcase-description">
                      Soft glow for children&apos;s rooms
                    </p>
                  </div>
                  <div className="showcase-card">
                    <img
                      alt="Handmade wooden clock"
                      src="https://images.pexels.com/photos/6654123/pexels-photo-6654123.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=400"
                      className="showcase-card-img"
                    />
                    <h3 className="showcase-title">Wooden Clock</h3>
                    <p className="showcase-description">
                      Timeless pieces for any space
                    </p>
                  </div>
                </div>
                <div className="showcase-card-overlay">
                  <span className="section-content">Rustic Discs</span>
                </div>
              </div>
              <div className="showcase-card">
                <img
                  alt="Festive wooden settings"
                  src="https://images.pexels.com/photos/7234428/pexels-photo-7234428.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  className="showcase-img"
                />
                <div className="showcase-card-overlay">
                  <span className="section-content">Table Charms</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="features-process-section">
        <div className="features-container">
          <div className="features-grid">
            <div className="feature-item">
              <div className="feature-icon-box">
                <svg
                  fill="none"
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-tree-pine"
                >
                  <path d="m17 14 3 3.3a1 1 0 0 1-.7 1.7H4.7a1 1 0 0 1-.7-1.7L7 14h-2l4.5-5H7l5-7 5 7h-2.5l4.5 5h-2Z"></path>
                  <path d="M12 22v-3"></path>
                </svg>
              </div>
              <h3 className="section-title">Sustainable Sourcing</h3>
              <p className="section-content">
                We only use timber from managed forests, ensuring every board
                supports the cycle of life.
              </p>
            </div>
            <div className="feature-item">
              <div className="feature-icon-box">
                <svg
                  fill="none"
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide-hammer lucide"
                >
                  <path d="m15 12-8.5 8.5c-.83.83-2.17.83-3 0 0 0 0 0 0 0a2.12 2.12 0 0 1 0-3L12 9"></path>
                  <path d="M17.64 15 22 10.64"></path>
                  <path d="m20.91 11.7-1.25-1.25c-.6-.6-.93-1.4-.93-2.25v-.86L16.01 4.6l-.86.86a3.18 3.18 0 0 1-2.25.93h-.86L9.36 3.71 5 8.07l4.36 4.36h.86c.85 0 1.65.33 2.25.93l.86.86 2.72-2.72h.86c.85 0 1.65.33 2.25.93l1.25 1.25 1.11-1.11Z"></path>
                  <path d="M15 12 8 5"></path>
                </svg>
              </div>
              <h3 className="section-title">Hand-Finished</h3>
              <p className="section-content">
                Each piece is sanded by hand and sealed with a food-safe blend
                of beeswax and mineral oil.
              </p>
            </div>
            <div className="feature-item">
              <div className="feature-icon-box">
                <svg
                  fill="none"
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide-heart lucide"
                >
                  <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"></path>
                </svg>
              </div>
              <h3 className="section-title">Lifetime Care</h3>
              <p className="section-content">
                Our boards are designed to be heirlooms. We provide care guides
                to keep them beautiful for decades.
              </p>
            </div>
            <div className="feature-item">
              <div className="feature-icon-box">
                <svg
                  fill="none"
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-award"
                >
                  <path d="m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526"></path>
                  <circle r="6" cx="12" cy="8"></circle>
                </svg>
              </div>
              <h3 className="section-title">Artisan Quality</h3>
              <p className="section-content">
                No mass production. Just one man, his workshop, and a dedication
                to quiet, masterful excellence.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="testimonials-moment-section">
        <div className="testimonials-container">
          <div className="testimonials-header">
            <h2 className="section-title">Stories from Your Home</h2>
            <p className="section-subtitle">
              Moments of connection, shared over wood
            </p>
          </div>
          <div className="testimonials-grid">
            <div className="testimonial-card">
              <img
                alt="Customer using board"
                src="https://images.pexels.com/photos/18795356/pexels-photo-18795356.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                className="testimonial-img"
              />
              <div className="testimonial-content">
                <p className="section-content">
                  &quot;The weight and texture of the oak board are incredible.
                  It has become the centerpiece of every Sunday roast.&quot;
                </p>
                <span className="testimonial-author">— Sarah J.</span>
              </div>
            </div>
            <div className="testimonial-card">
              <img
                alt="Special occasion setup"
                src="https://images.pexels.com/photos/7234428/pexels-photo-7234428.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                className="testimonial-img"
              />
              <div className="testimonial-content">
                <p className="section-content">
                  &quot;I bought a board for my daughter&apos;s wedding.
                  It&apos;s more than a gift; it&apos;s a piece of history they
                  can keep forever.&quot;
                </p>
                <span className="testimonial-author">— Robert M.</span>
              </div>
            </div>
            <div className="testimonial-card">
              <img
                alt="Gifting moment"
                src="https://images.pexels.com/photos/6755799/pexels-photo-6755799.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                className="testimonial-img"
              />
              <div className="testimonial-content">
                <p className="section-content">
                  &quot;The Christmas decorations are so charming. You can
                  really feel the care that went into every single one.&quot;
                </p>
                <span className="testimonial-author">— Elena W.</span>
              </div>
            </div>
            <div className="testimonial-card">
              <img
                alt="Artisan detail"
                src="https://images.pexels.com/photos/5490176/pexels-photo-5490176.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                className="testimonial-img"
              />
              <div className="testimonial-content">
                <p className="section-content">
                  &quot;Seeing the workshop photos made me appreciate the board
                  even more. It&apos;s rare to find such authentic craft.&quot;
                </p>
                <span className="testimonial-author">— David L.</span>
              </div>
            </div>
            <div className="testimonial-card">
              <img
                alt="Outdoor serving"
                src="https://images.pexels.com/photos/32528911/pexels-photo-32528911.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                className="testimonial-img"
              />
              <div className="testimonial-content">
                <p className="section-content">
                  &quot;Evelynis boards have a soul. They age beautifully and
                  only get better with every use and oiling.&quot;
                </p>
                <span className="testimonial-author">— Mia K.</span>
              </div>
            </div>
            <div className="testimonial-card">
              <img
                alt="Kitchen display"
                src="https://images.pexels.com/photos/18947372/pexels-photo-18947372.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                className="testimonial-img"
              />
              <div className="testimonial-content">
                <p className="section-content">
                  &quot;The best kitchen investment I&apos;ve made. It feels
                  like a piece of the forest has been brought into my
                  home.&quot;
                </p>
                <span className="testimonial-author">— Thomas B.</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="gallery-atmosphere-section">
        <div className="gallery-grid">
          <div className="gallery-item">
            <img
              alt="Sunlit workshop window"
              src="https://images.pexels.com/photos/4888897/pexels-photo-4888897.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
              className="gallery-img"
            />
          </div>
          <div className="gallery-item">
            <img
              alt="Wood shavings and textures"
              src="https://images.pexels.com/photos/7479030/pexels-photo-7479030.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
              className="gallery-img"
            />
          </div>
          <div className="gallery-item">
            <img
              alt="Cozy workshop workbench"
              src="https://images.pexels.com/photos/5089154/pexels-photo-5089154.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
              className="gallery-img"
            />
          </div>
          <div className="gallery-item">
            <img
              alt="Skilled hands shaping wood"
              src="https://images.pexels.com/photos/5711767/pexels-photo-5711767.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
              className="gallery-img"
            />
          </div>
          <div className="gallery-item">
            <img
              alt="Organized wooden samples"
              src="https://images.pexels.com/photos/5089133/pexels-photo-5089133.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
              className="gallery-img"
            />
          </div>
          <div className="gallery-item">
            <img
              alt="Detailed wood grain close-up"
              src="https://images.pexels.com/photos/7479028/pexels-photo-7479028.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
              className="gallery-img"
            />
          </div>
        </div>
      </section>
      <section className="cta-final-section">
        <div className="cta-container">
          <div className="cta-card">
            <h2 className="section-title">Bring the Forest Home</h2>
            <p className="section-content">
              Explore our full range of handcrafted boards and seasonal
              decorations, each one made with legacy and care in Wiltshire.
            </p>
            <div className="cta-buttons">
              <a href="#">
                <div className="btn-xl btn-primary btn">
                  <span>Shop Full Collection</span>
                </div>
              </a>
              <a href="#">
                <div className="btn-xl btn btn-secondary">
                  <span>Browse Christmas Items</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>
      <div className="home-container2">
        <div className="home-container3">
          <Script
            html={`<script defer data-name="hero-parallax">
(function(){
  const heroBg = document.getElementById("hero-bg")

  window.addEventListener("scroll", () => {
    const scrollY = window.pageYOffset
    if (heroBg) {
      heroBg.style.transform = \`translateY(\${scrollY * 0.3}px)\`
    }
  })

  // Simple scroll reveal for about section image
  const aboutImage = document.querySelector(".about-image")
  if (aboutImage) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.style.transform = "scale(1.05)"
            setTimeout(() => {
              entry.target.style.transform = "scale(1)"
            }, 800)
          }
        })
      },
      { threshold: 0.2 }
    )

    observer.observe(aboutImage)
  }
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
      <a href="https://play.teleporthq.io/signup">
        <div aria-label="Sign up to TeleportHQ" className="home-container4">
          <svg
            width="24"
            height="24"
            viewBox="0 0 19 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="home-icon19"
          >
            <path
              d="M9.1017 4.64355H2.17867C0.711684 4.64355 -0.477539 5.79975 -0.477539 7.22599V13.9567C-0.477539 15.3829 0.711684 16.5391 2.17867 16.5391H9.1017C10.5687 16.5391 11.7579 15.3829 11.7579 13.9567V7.22599C11.7579 5.79975 10.5687 4.64355 9.1017 4.64355Z"
              fill="#B23ADE"
            ></path>
            <path
              d="M10.9733 12.7878C14.4208 12.7878 17.2156 10.0706 17.2156 6.71886C17.2156 3.3671 14.4208 0.649963 10.9733 0.649963C7.52573 0.649963 4.73096 3.3671 4.73096 6.71886C4.73096 10.0706 7.52573 12.7878 10.9733 12.7878Z"
              fill="#FF5C5C"
            ></path>
            <path
              d="M17.7373 13.3654C19.1497 14.1588 19.1497 15.4634 17.7373 16.2493L10.0865 20.5387C8.67402 21.332 7.51855 20.6836 7.51855 19.0968V10.5141C7.51855 8.92916 8.67402 8.2807 10.0865 9.07221L17.7373 13.3654Z"
              fill="#2874DE"
            ></path>
          </svg>
          <span className="home-text8">Built in TeleportHQ</span>
        </div>
      </a>
    </div>
  )
}

export default Home
